/*
 * @Author: AI Assistant
 * @Date: 2026-01-15
 * @Description: 签到弹窗相关多语言配置（邀请好友、任务中心）
 * @FilePath: /weryai-web/locales/modules/signIn.ts
 */
export default {
    zh: {
        signIn: {
            // 邀请好友
            inviteFriends: '邀请好友',
            todayLimit: '今日上限',
            copyLink: '复制链接',
            copySuccess: '复制成功',
            validInvites: '有效邀请',
            people: '人',
            today: '今日',
            pending: '待领取',
            claimNow: '立即领取',
            claimSuccess: '领取成功',
            claimFailed: '领取失败，请稍后再试',
            noPendingRewards: '暂无可领取的奖励',
            forEachFriend: '每邀请一位好友',
            ruleText: '规则：好友需通过您的链接注册并',
            completeGeneration: '完成一次AI生成',
            afterReward: '后发放奖励。',
            dailyLimitTip: '* 每日邀请奖励上限为 10 人，次日自动刷新。',
            promotionText:
                '想免费使用nanobanna、VEO、seedream?注册WeryAI就能领免费积分，立刻就能体验AI创作的乐趣！',
            // 任务中心
            taskCenter: '任务中心',
            addToDesktop: '将WeryAI添加到桌面并从桌面访问',
            goComplete: '去完成',
            completed: '已完成',
            tokens: '积分',
            // PWA 引导弹窗
            pwaGuideTitle: '把 微鲤AI 放到桌面',
            pwaGuideDesc: '打开更快、更沉浸，不用每次找浏览器',
            browserNotSupported: '您的浏览器暂不支持此功能，建议使用 Chrome、Edge 或 Safari 浏览器',
            // PWA 步骤文案
            pwaStepChrome1: '点击顶部的添加到桌面的icon',
            pwaStepChrome2: '点击安装',
            pwaStepEdge1: '点击顶部的添加到桌面的icon',
            pwaStepEdge2: '点击安装',
            pwaStepSafari1: '点击更多icon',
            pwaStepSafari2: '点击分享',
            pwaStepSafari3: '点击更多',
            pwaStepSafari4: '点击添加到主屏幕',
            pwaStepSafari5: '点击添加',
            // PWA 提示卡片
            pwaPromptTitle: '将WeryAI添加到桌面',
            pwaPromptDesc: '添加到主屏幕，领取15积分奖励',
            pwaPromptBtn: '添加',
        },
    },
    en: {
        signIn: {
            // Invite Friends
            inviteFriends: 'Invite Friends',
            todayLimit: "Today's Limit",
            copyLink: 'Copy Link',
            copySuccess: 'Copied',
            validInvites: 'Valid Invites',
            people: 'people',
            today: 'Today',
            pending: 'Pending',
            claimNow: 'Claim Now',
            claimSuccess: 'Claimed successfully',
            claimFailed: 'Claim failed, please try again later',
            noPendingRewards: 'No rewards to claim',
            forEachFriend: 'For each friend invited',
            ruleText: 'Rule: Friend must register via your link and',
            completeGeneration: 'complete one AI generation',
            afterReward: 'to receive reward.',
            dailyLimitTip:
                '* Daily invite reward limit is 10 people, refreshes next day.',
            promotionText:
                'Want to use nanobanna, VEO, seedream for free? Register 微鲤AI to get free tokens and experience the joy of AI creation!',
            // Task Center
            taskCenter: 'Task Center',
            addToDesktop: 'Add 微鲤AI to desktop and access from desktop',
            goComplete: 'Go',
            completed: 'Completed',
            tokens: 'Credits',
            // PWA Guide Modal
            pwaGuideTitle: 'Put 微鲤AI on Your Desktop',
            pwaGuideDesc: 'Opens faster, more immersive, no need to find browser every time',
            browserNotSupported: 'Your browser does not support this feature. Please use Chrome, Edge, or Safari',
            // PWA Step Text
            pwaStepChrome1: 'Click the "Add to Desktop" icon at the top',
            pwaStepChrome2: 'Click Install',
            pwaStepEdge1: 'Click the "Add to Desktop" icon at the top',
            pwaStepEdge2: 'Click Install',
            pwaStepSafari1: 'Click the More icon',
            pwaStepSafari2: 'Click Share',
            pwaStepSafari3: 'Click More',
            pwaStepSafari4: 'Click Add to Home Screen',
            pwaStepSafari5: 'Click Add',
            // PWA Prompt Card
            pwaPromptTitle: 'Add 微鲤AI to Desktop',
            pwaPromptDesc: 'Add to home screen and get 15 tokens',
            pwaPromptBtn: 'Add',
        },
    },
    ja: {
        signIn: {
            inviteFriends: '友達を招待',
            todayLimit: '本日の上限',
            copyLink: 'リンクをコピー',
            copySuccess: 'コピーしました',
            validInvites: '有効な招待',
            people: '人',
            today: '今日',
            pending: '受取待ち',
            claimNow: '今すぐ受け取る',
            claimSuccess: '受け取りました',
            claimFailed: '受け取りに失敗しました。後でもう一度お試しください',
            noPendingRewards: '受け取れる報酬がありません',
            forEachFriend: '友達を1人招待するごとに',
            ruleText: 'ルール：友達があなたのリンクから登録し、',
            completeGeneration: 'AI生成を1回完了',
            afterReward: 'すると報酬が付与されます。',
            dailyLimitTip:
                '* 1日の招待報酬上限は10人です。翌日に自動更新されます。',
            promotionText:
                'nanobanna、VEO、seedreamを無料で使いたいですか？WeryAIに登録すれば無料ポイントがもらえて、すぐにAI創作の楽しさを体験できます！',
            taskCenter: 'タスクセンター',
            addToDesktop: 'WeryAIをデスクトップに追加してアクセス',
            goComplete: '完了する',
            completed: '完了',
            tokens: 'クレジット',
            // PWA ガイドモーダル
            pwaGuideTitle: 'WeryAIをデスクトップに置く',
            pwaGuideDesc: 'より速く開き、より没入感があり、毎回ブラウザを探す必要がありません',
            browserNotSupported: 'お使いのブラウザはこの機能に対応していません。Chrome、Edge、またはSafariをご利用ください',
            // PWA ステップテキスト
            pwaStepChrome1: '上部の「デスクトップに追加」アイコンをクリック',
            pwaStepChrome2: 'インストールをクリック',
            pwaStepEdge1: '上部の「デスクトップに追加」アイコンをクリック',
            pwaStepEdge2: 'インストールをクリック',
            pwaStepSafari1: '「その他」アイコンをクリック',
            pwaStepSafari2: '共有をクリック',
            pwaStepSafari3: 'その他をクリック',
            pwaStepSafari4: '「ホーム画面に追加」をクリック',
            pwaStepSafari5: '追加をクリック',
            // PWA プロンプトカード
            pwaPromptTitle: 'WeryAIをデスクトップに追加',
            pwaPromptDesc: 'ホーム画面に追加して15ポイント獲得',
            pwaPromptBtn: '追加',
        },
    },
    ko: {
        signIn: {
            inviteFriends: '친구 초대',
            todayLimit: '오늘 한도',
            copyLink: '링크 복사',
            copySuccess: '복사됨',
            validInvites: '유효 초대',
            people: '명',
            today: '오늘',
            pending: '수령 대기',
            claimNow: '지금 받기',
            claimSuccess: '수령 완료',
            claimFailed: '수령 실패, 나중에 다시 시도해주세요',
            noPendingRewards: '수령할 보상이 없습니다',
            forEachFriend: '친구 1명 초대 시',
            ruleText: '규칙: 친구가 링크로 가입하고',
            completeGeneration: 'AI 생성 1회 완료',
            afterReward: ' 후 보상이 지급됩니다.',
            dailyLimitTip: '* 일일 초대 보상 한도는 10명이며, 다음 날 자동 갱신됩니다.',
            promotionText:
                'nanobanna, VEO, seedream을 무료로 사용하고 싶으신가요? WeryAI에 가입하면 무료 포인트를 받고 바로 AI 창작의 즐거움을 경험할 수 있습니다!',
            taskCenter: '태스크 센터',
            addToDesktop: 'WeryAI를 데스크톱에 추가하고 접속하기',
            goComplete: '완료하기',
            completed: '완료됨',
            tokens: '크레딧',
            // PWA 가이드 모달
            pwaGuideTitle: 'WeryAI를 데스크톱에 놓기',
            pwaGuideDesc: '더 빠르게 열리고, 더 몰입감 있고, 매번 브라우저를 찾을 필요 없음',
            browserNotSupported: '현재 브라우저는 이 기능을 지원하지 않습니다. Chrome, Edge 또는 Safari를 사용해 주세요',
            // PWA 단계 텍스트
            pwaStepChrome1: '상단의 "데스크톱에 추가" 아이콘을 클릭',
            pwaStepChrome2: '설치를 클릭',
            pwaStepEdge1: '상단의 "데스크톱에 추가" 아이콘을 클릭',
            pwaStepEdge2: '설치를 클릭',
            pwaStepSafari1: '더보기 아이콘 클릭',
            pwaStepSafari2: '공유 클릭',
            pwaStepSafari3: '더보기 클릭',
            pwaStepSafari4: '홈 화면에 추가 클릭',
            pwaStepSafari5: '추가 클릭',
            // PWA 프롬프트 카드
            pwaPromptTitle: 'WeryAI를 바탕화면에 추가',
            pwaPromptDesc: '홈 화면에 추가하고 15포인트 받기',
            pwaPromptBtn: '추가',
        },
    },
    es: {
        signIn: {
            inviteFriends: 'Invitar Amigos',
            todayLimit: 'Límite de Hoy',
            copyLink: 'Copiar Enlace',
            copySuccess: 'Copiado',
            validInvites: 'Invitaciones Válidas',
            people: 'personas',
            today: 'Hoy',
            pending: 'Pendiente',
            claimNow: 'Reclamar Ahora',
            claimSuccess: 'Reclamado con éxito',
            claimFailed: 'Error al reclamar, inténtalo más tarde',
            noPendingRewards: 'No hay recompensas para reclamar',
            forEachFriend: 'Por cada amigo invitado',
            ruleText: 'Regla: Tu amigo debe registrarse con tu enlace y',
            completeGeneration: 'completar una generación de IA',
            afterReward: 'para recibir la recompensa.',
            dailyLimitTip:
                '* Límite diario de recompensa por invitación: 10 personas, se actualiza al día siguiente.',
            promotionText:
                '¿Quieres usar nanobanna, VEO, seedream gratis? ¡Regístrate en 微鲤AI para obtener tokens gratis y experimentar la alegría de la creación con IA!',
            taskCenter: 'Centro de Tareas',
            addToDesktop: 'Añadir 微鲤AI al escritorio y acceder desde ahí',
            goComplete: 'Ir',
            completed: 'Completado',
            tokens: 'Créditos',
            // Modal de guía PWA
            pwaGuideTitle: 'Pon 微鲤AI en tu escritorio',
            pwaGuideDesc: 'Se abre más rápido, más inmersivo, sin buscar el navegador cada vez',
            browserNotSupported: 'Tu navegador no soporta esta función. Por favor usa Chrome, Edge o Safari',
            // Texto de pasos PWA
            pwaStepChrome1: 'Haz clic en el icono "Añadir al escritorio" en la parte superior',
            pwaStepChrome2: 'Haz clic en Instalar',
            pwaStepEdge1: 'Haz clic en el icono "Añadir al escritorio" en la parte superior',
            pwaStepEdge2: 'Haz clic en Instalar',
            pwaStepSafari1: 'Haz clic en el icono Más',
            pwaStepSafari2: 'Haz clic en Compartir',
            pwaStepSafari3: 'Haz clic en Más',
            pwaStepSafari4: 'Haz clic en Añadir a pantalla de inicio',
            pwaStepSafari5: 'Haz clic en Añadir',
            // Tarjeta de solicitud PWA
            pwaPromptTitle: 'Añadir 微鲤AI al escritorio',
            pwaPromptDesc: 'Añadir a pantalla de inicio y obtener 15 puntos',
            pwaPromptBtn: 'Añadir',
        },
    },
    fr: {
        signIn: {
            inviteFriends: 'Inviter des Amis',
            todayLimit: "Limite d'Aujourd'hui",
            copyLink: 'Copier le Lien',
            copySuccess: 'Copié',
            validInvites: 'Invitations Valides',
            people: 'personnes',
            today: "Aujourd'hui",
            pending: 'En Attente',
            claimNow: 'Réclamer',
            claimSuccess: 'Réclamé avec succès',
            claimFailed: 'Échec de la réclamation, réessayez plus tard',
            noPendingRewards: 'Aucune récompense à réclamer',
            forEachFriend: 'Pour chaque ami invité',
            ruleText: "Règle: Votre ami doit s'inscrire via votre lien et",
            completeGeneration: 'compléter une génération IA',
            afterReward: 'pour recevoir la récompense.',
            dailyLimitTip:
                "* Limite quotidienne de récompense d'invitation: 10 personnes, actualisée le lendemain.",
            promotionText:
                "Vous voulez utiliser nanobanna, VEO, seedream gratuitement? Inscrivez-vous sur 微鲤AI pour obtenir des tokens gratuits et découvrir la joie de la création IA!",
            taskCenter: 'Centre de Tâches',
            addToDesktop: "Ajouter 微鲤AI au bureau et y accéder",
            goComplete: 'Aller',
            completed: 'Terminé',
            tokens: 'Crédits',
            // Modal de guide PWA
            pwaGuideTitle: 'Mettez 微鲤AI sur votre bureau',
            pwaGuideDesc: 'S\'ouvre plus vite, plus immersif, sans chercher le navigateur à chaque fois',
            browserNotSupported: 'Votre navigateur ne prend pas en charge cette fonctionnalité. Veuillez utiliser Chrome, Edge ou Safari',
            // Texte des étapes PWA
            pwaStepChrome1: 'Cliquez sur l\'icône "Ajouter au bureau" en haut',
            pwaStepChrome2: 'Cliquez sur Installer',
            pwaStepEdge1: 'Cliquez sur l\'icône "Ajouter au bureau" en haut',
            pwaStepEdge2: 'Cliquez sur Installer',
            pwaStepSafari1: 'Cliquez sur l\'icône Plus',
            pwaStepSafari2: 'Cliquez sur Partager',
            pwaStepSafari3: 'Cliquez sur Plus',
            pwaStepSafari4: 'Cliquez sur Ajouter à l\'écran d\'accueil',
            pwaStepSafari5: 'Cliquez sur Ajouter',
            // Carte de demande PWA
            pwaPromptTitle: 'Ajouter 微鲤AI au bureau',
            pwaPromptDesc: "Ajouter à l'écran d'accueil et obtenir 15 points",
            pwaPromptBtn: 'Ajouter',
        },
    },
    de: {
        signIn: {
            inviteFriends: 'Freunde Einladen',
            todayLimit: 'Heutiges Limit',
            copyLink: 'Link Kopieren',
            copySuccess: 'Kopiert',
            validInvites: 'Gültige Einladungen',
            people: 'Personen',
            today: 'Heute',
            pending: 'Ausstehend',
            claimNow: 'Jetzt Abholen',
            claimSuccess: 'Erfolgreich abgeholt',
            claimFailed: 'Abholen fehlgeschlagen, bitte später erneut versuchen',
            noPendingRewards: 'Keine Belohnungen zum Abholen',
            forEachFriend: 'Für jeden eingeladenen Freund',
            ruleText:
                'Regel: Ihr Freund muss sich über Ihren Link registrieren und',
            completeGeneration: 'eine KI-Generierung abschließen',
            afterReward: 'um die Belohnung zu erhalten.',
            dailyLimitTip:
                '* Tägliches Einladungslimit: 10 Personen, wird am nächsten Tag aktualisiert.',
            promotionText:
                'Möchten Sie nanobanna, VEO, seedream kostenlos nutzen? Registrieren Sie sich bei 微鲤AI und erhalten Sie kostenlose Tokens und erleben Sie die Freude der KI-Kreation!',
            taskCenter: 'Aufgabenzentrum',
            addToDesktop: '微鲤AI zum Desktop hinzufügen und darauf zugreifen',
            goComplete: 'Los',
            completed: 'Abgeschlossen',
            tokens: 'Credits',
            // PWA-Anleitungsmodal
            pwaGuideTitle: '微鲤AI auf den Desktop legen',
            pwaGuideDesc: 'Öffnet schneller, immersiver, ohne jedes Mal den Browser zu suchen',
            browserNotSupported: 'Ihr Browser unterstützt diese Funktion nicht. Bitte verwenden Sie Chrome, Edge oder Safari',
            // PWA-Schritttext
            pwaStepChrome1: 'Klicken Sie oben auf das Symbol "Zum Desktop hinzufügen"',
            pwaStepChrome2: 'Klicken Sie auf Installieren',
            pwaStepEdge1: 'Klicken Sie oben auf das Symbol "Zum Desktop hinzufügen"',
            pwaStepEdge2: 'Klicken Sie auf Installieren',
            pwaStepSafari1: 'Klicken Sie auf das Mehr-Symbol',
            pwaStepSafari2: 'Klicken Sie auf Teilen',
            pwaStepSafari3: 'Klicken Sie auf Mehr',
            pwaStepSafari4: 'Klicken Sie auf Zum Home-Bildschirm hinzufügen',
            pwaStepSafari5: 'Klicken Sie auf Hinzufügen',
            // PWA-Aufforderungskarte
            pwaPromptTitle: '微鲤AI zum Desktop hinzufügen',
            pwaPromptDesc: 'Zum Startbildschirm hinzufügen und 15 Punkte erhalten',
            pwaPromptBtn: 'Hinzufügen',
        },
    },
    ru: {
        signIn: {
            inviteFriends: 'Пригласить Друзей',
            todayLimit: 'Лимит Сегодня',
            copyLink: 'Копировать Ссылку',
            copySuccess: 'Скопировано',
            validInvites: 'Действительные Приглашения',
            people: 'человек',
            today: 'Сегодня',
            pending: 'Ожидает',
            claimNow: 'Получить Сейчас',
            claimSuccess: 'Успешно получено',
            claimFailed: 'Ошибка получения, попробуйте позже',
            noPendingRewards: 'Нет наград для получения',
            forEachFriend: 'За каждого приглашённого друга',
            ruleText:
                'Правило: Друг должен зарегистрироваться по вашей ссылке и',
            completeGeneration: 'выполнить одну генерацию ИИ',
            afterReward: 'для получения награды.',
            dailyLimitTip:
                '* Дневной лимит награды за приглашение: 10 человек, обновляется на следующий день.',
            promotionText:
                'Хотите бесплатно использовать nanobanna, VEO, seedream? Зарегистрируйтесь в 微鲤AI и получите бесплатные токены, чтобы испытать радость ИИ-творчества!',
            taskCenter: 'Центр Задач',
            addToDesktop: 'Добавить 微鲤AI на рабочий стол и открывать оттуда',
            goComplete: 'Перейти',
            completed: 'Выполнено',
            tokens: 'Кредиты',
            // Модальное окно руководства PWA
            pwaGuideTitle: 'Разместите 微鲤AI на рабочем столе',
            pwaGuideDesc: 'Открывается быстрее, более погружающий, не нужно каждый раз искать браузер',
            browserNotSupported: 'Ваш браузер не поддерживает эту функцию. Пожалуйста, используйте Chrome, Edge или Safari',
            // Текст шагов PWA
            pwaStepChrome1: 'Нажмите на значок "Добавить на рабочий стол" вверху',
            pwaStepChrome2: 'Нажмите Установить',
            pwaStepEdge1: 'Нажмите на значок "Добавить на рабочий стол" вверху',
            pwaStepEdge2: 'Нажмите Установить',
            pwaStepSafari1: 'Нажмите на значок Ещё',
            pwaStepSafari2: 'Нажмите Поделиться',
            pwaStepSafari3: 'Нажмите Ещё',
            pwaStepSafari4: 'Нажмите Добавить на главный экран',
            pwaStepSafari5: 'Нажмите Добавить',
            // Карточка приглашения PWA
            pwaPromptTitle: 'Добавить 微鲤AI на рабочий стол',
            pwaPromptDesc: 'Добавить на главный экран и получить 15 баллов',
            pwaPromptBtn: 'Добавить',
        },
    },
    pt: {
        signIn: {
            inviteFriends: 'Convidar Amigos',
            todayLimit: 'Limite de Hoje',
            copyLink: 'Copiar Link',
            copySuccess: 'Copiado',
            validInvites: 'Convites Válidos',
            people: 'pessoas',
            today: 'Hoje',
            pending: 'Pendente',
            claimNow: 'Resgatar Agora',
            claimSuccess: 'Resgatado com sucesso',
            claimFailed: 'Falha ao resgatar, tente novamente mais tarde',
            noPendingRewards: 'Não há recompensas para resgatar',
            forEachFriend: 'Para cada amigo convidado',
            ruleText: 'Regra: Seu amigo deve se registrar pelo seu link e',
            completeGeneration: 'completar uma geração de IA',
            afterReward: 'para receber a recompensa.',
            dailyLimitTip:
                '* Limite diário de recompensa por convite: 10 pessoas, atualizado no dia seguinte.',
            promotionText:
                'Quer usar nanobanna, VEO, seedream de graça? Registre-se no 微鲤AI para ganhar tokens grátis e experimentar a alegria da criação com IA!',
            taskCenter: 'Central de Tarefas',
            addToDesktop: 'Adicionar 微鲤AI à área de trabalho e acessar dali',
            goComplete: 'Ir',
            completed: 'Concluído',
            tokens: 'Créditos',
            // Modal de guia PWA
            pwaGuideTitle: 'Coloque o 微鲤AI na área de trabalho',
            pwaGuideDesc: 'Abre mais rápido, mais imersivo, sem precisar procurar o navegador toda vez',
            browserNotSupported: 'Seu navegador não suporta este recurso. Por favor, use Chrome, Edge ou Safari',
            // Texto das etapas PWA
            pwaStepChrome1: 'Clique no ícone "Adicionar à área de trabalho" no topo',
            pwaStepChrome2: 'Clique em Instalar',
            pwaStepEdge1: 'Clique no ícone "Adicionar à área de trabalho" no topo',
            pwaStepEdge2: 'Clique em Instalar',
            pwaStepSafari1: 'Clique no ícone Mais',
            pwaStepSafari2: 'Clique em Compartilhar',
            pwaStepSafari3: 'Clique em Mais',
            pwaStepSafari4: 'Clique em Adicionar à Tela de Início',
            pwaStepSafari5: 'Clique em Adicionar',
            // Cartão de solicitação PWA
            pwaPromptTitle: 'Adicionar 微鲤AI à área de trabalho',
            pwaPromptDesc: 'Adicionar à tela inicial e ganhar 15 pontos',
            pwaPromptBtn: 'Adicionar',
        },
    },
    it: {
        signIn: {
            inviteFriends: 'Invita Amici',
            todayLimit: 'Limite di Oggi',
            copyLink: 'Copia Link',
            copySuccess: 'Copiato',
            validInvites: 'Inviti Validi',
            people: 'persone',
            today: 'Oggi',
            pending: 'In Attesa',
            claimNow: 'Riscuoti Ora',
            claimSuccess: 'Riscosso con successo',
            claimFailed: 'Riscossione fallita, riprova più tardi',
            noPendingRewards: 'Nessuna ricompensa da riscuotere',
            forEachFriend: 'Per ogni amico invitato',
            ruleText: 'Regola: Il tuo amico deve registrarsi tramite il tuo link e',
            completeGeneration: 'completare una generazione IA',
            afterReward: 'per ricevere la ricompensa.',
            dailyLimitTip:
                "* Limite giornaliero di ricompensa per invito: 10 persone, si aggiorna il giorno successivo.",
            promotionText:
                'Vuoi usare nanobanna, VEO, seedream gratis? Registrati su 微鲤AI per ottenere token gratuiti e provare la gioia della creazione con IA!',
            taskCenter: 'Centro Attività',
            addToDesktop: 'Aggiungi 微鲤AI al desktop e accedi da lì',
            goComplete: 'Vai',
            completed: 'Completato',
            tokens: 'Crediti',
            // Modale guida PWA
            pwaGuideTitle: 'Metti 微鲤AI sul desktop',
            pwaGuideDesc: 'Si apre più veloce, più immersivo, senza cercare il browser ogni volta',
            browserNotSupported: 'Il tuo browser non supporta questa funzione. Per favore usa Chrome, Edge o Safari',
            // Testo dei passaggi PWA
            pwaStepChrome1: 'Clicca sull\'icona "Aggiungi al desktop" in alto',
            pwaStepChrome2: 'Clicca su Installa',
            pwaStepEdge1: 'Clicca sull\'icona "Aggiungi al desktop" in alto',
            pwaStepEdge2: 'Clicca su Installa',
            pwaStepSafari1: 'Clicca sull\'icona Altro',
            pwaStepSafari2: 'Clicca su Condividi',
            pwaStepSafari3: 'Clicca su Altro',
            pwaStepSafari4: 'Clicca su Aggiungi alla schermata Home',
            pwaStepSafari5: 'Clicca su Aggiungi',
            // Scheda di richiesta PWA
            pwaPromptTitle: 'Aggiungi 微鲤AI al desktop',
            pwaPromptDesc: 'Aggiungi alla schermata iniziale e ottieni 15 punti',
            pwaPromptBtn: 'Aggiungi',
        },
    },
    ar: {
        signIn: {
            inviteFriends: 'دعوة الأصدقاء',
            todayLimit: 'حد اليوم',
            copyLink: 'نسخ الرابط',
            copySuccess: 'تم النسخ',
            validInvites: 'الدعوات الصالحة',
            people: 'أشخاص',
            today: 'اليوم',
            pending: 'معلق',
            claimNow: 'استلم الآن',
            claimSuccess: 'تم الاستلام بنجاح',
            claimFailed: 'فشل الاستلام، حاول مرة أخرى لاحقًا',
            noPendingRewards: 'لا توجد مكافآت للاستلام',
            forEachFriend: 'لكل صديق مدعو',
            ruleText: 'القاعدة: يجب على صديقك التسجيل عبر رابطك و',
            completeGeneration: 'إكمال عملية إنشاء ذكاء اصطناعي واحدة',
            afterReward: 'للحصول على المكافأة.',
            dailyLimitTip:
                '* حد المكافأة اليومي للدعوات: 10 أشخاص، يتم التحديث في اليوم التالي.',
            promotionText:
                'هل تريد استخدام nanobanna و VEO و seedream مجانًا؟ سجل في 微鲤AI للحصول على رموز مجانية واستمتع بتجربة إبداع الذكاء الاصطناعي!',
            taskCenter: 'مركز المهام',
            addToDesktop: 'أضف 微鲤AI إلى سطح المكتب والوصول منه',
            goComplete: 'اذهب',
            completed: 'مكتمل',
            tokens: 'رصيد',
            // نافذة دليل PWA
            pwaGuideTitle: 'ضع 微鲤AI على سطح المكتب',
            pwaGuideDesc: 'يفتح أسرع، أكثر انغماسًا، دون الحاجة للبحث عن المتصفح في كل مرة',
            browserNotSupported: 'متصفحك لا يدعم هذه الميزة. يرجى استخدام Chrome أو Edge أو Safari',
            // نص خطوات PWA
            pwaStepChrome1: 'انقر على أيقونة "إضافة إلى سطح المكتب" في الأعلى',
            pwaStepChrome2: 'انقر على تثبيت',
            pwaStepEdge1: 'انقر على أيقونة "إضافة إلى سطح المكتب" في الأعلى',
            pwaStepEdge2: 'انقر على تثبيت',
            pwaStepSafari1: 'انقر على أيقونة المزيد',
            pwaStepSafari2: 'انقر على مشاركة',
            pwaStepSafari3: 'انقر على المزيد',
            pwaStepSafari4: 'انقر على إضافة إلى الشاشة الرئيسية',
            pwaStepSafari5: 'انقر على إضافة',
            // بطاقة طلب PWA
            pwaPromptTitle: 'أضف 微鲤AI إلى سطح المكتب',
            pwaPromptDesc: 'أضف إلى الشاشة الرئيسية واحصل على 15 نقطة',
            pwaPromptBtn: 'إضافة',
        },
    },
    tw: {
        signIn: {
            // 邀請好友
            inviteFriends: '邀請好友',
            todayLimit: '今日上限',
            copyLink: '複製連結',
            copySuccess: '複製成功',
            validInvites: '有效邀請',
            people: '人',
            today: '今日',
            pending: '待領取',
            claimNow: '立即領取',
            claimSuccess: '領取成功',
            claimFailed: '領取失敗，請稍後再試',
            noPendingRewards: '暫無可領取的獎勵',
            forEachFriend: '每邀請一位好友',
            ruleText: '規則：好友需通過您的連結註冊並',
            completeGeneration: '完成一次AI生成',
            afterReward: '後發放獎勵。',
            dailyLimitTip: '* 每日邀請獎勵上限為 10 人，次日自動刷新。',
            promotionText:
                '想免費使用nanobanna、VEO、seedream?註冊WeryAI就能領免費積分，立刻就能體驗AI創作的樂趣！',
            // 任務中心
            taskCenter: '任務中心',
            addToDesktop: '將WeryAI添加到桌面並從桌面訪問',
            goComplete: '去完成',
            completed: '已完成',
            tokens: '積分',
            // PWA 引導彈窗
            pwaGuideTitle: '把 微鲤AI 放到桌面',
            pwaGuideDesc: '開啟更快、更沉浸，不用每次找瀏覽器',
            browserNotSupported: '您的瀏覽器暫不支援此功能，建議使用 Chrome、Edge 或 Safari 瀏覽器',
            // PWA 步驟文案
            pwaStepChrome1: '點擊頂部的添加到桌面的icon',
            pwaStepChrome2: '點擊安裝',
            pwaStepEdge1: '點擊頂部的添加到桌面的icon',
            pwaStepEdge2: '點擊安裝',
            pwaStepSafari1: '點擊更多icon',
            pwaStepSafari2: '點擊分享',
            pwaStepSafari3: '點擊更多',
            pwaStepSafari4: '點擊添加到主螢幕',
            pwaStepSafari5: '點擊添加',
            // PWA 提示卡片
            pwaPromptTitle: '將WeryAI添加到桌面',
            pwaPromptDesc: '添加到主螢幕，領取15積分獎勵',
            pwaPromptBtn: '添加',
        },
    },
    th: {
        signIn: {
            inviteFriends: 'เชิญเพื่อน',
            todayLimit: 'จำกัดวันนี้',
            copyLink: 'คัดลอกลิงก์',
            copySuccess: 'คัดลอกแล้ว',
            validInvites: 'คำเชิญที่ถูกต้อง',
            people: 'คน',
            today: 'วันนี้',
            pending: 'รอดำเนินการ',
            claimNow: 'รับเลย',
            claimSuccess: 'รับสำเร็จ',
            claimFailed: 'รับไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
            noPendingRewards: 'ไม่มีรางวัลให้รับ',
            forEachFriend: 'สำหรับเพื่อนแต่ละคนที่เชิญ',
            ruleText: 'กฎ: เพื่อนต้องลงทะเบียนผ่านลิงก์ของคุณและ',
            completeGeneration: 'สร้าง AI หนึ่งครั้ง',
            afterReward: 'เพื่อรับรางวัล',
            dailyLimitTip: '* จำกัดรางวัลเชิญต่อวัน 10 คน รีเฟรชวันถัดไป',
            promotionText:
                'อยากใช้ nanobanna, VEO, seedream ฟรีไหม? สมัคร 微鲤AI รับโทเคนฟรีและสัมผัสความสนุกของการสร้าง AI!',
            taskCenter: 'ศูนย์ภารกิจ',
            addToDesktop: 'เพิ่ม 微鲤AI ไปยังเดสก์ท็อปและเข้าถึงจากที่นั่น',
            goComplete: 'ไป',
            completed: 'เสร็จสิ้น',
            tokens: 'เครดิต',
            pwaGuideTitle: 'วาง 微鲤AI บนเดสก์ท็อป',
            pwaGuideDesc: 'เปิดเร็วขึ้น ดื่มด่ำมากขึ้น ไม่ต้องหาเบราว์เซอร์ทุกครั้ง',
            browserNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับฟีเจอร์นี้ กรุณาใช้ Chrome, Edge หรือ Safari',
            pwaStepChrome1: 'คลิกไอคอน "เพิ่มไปยังเดสก์ท็อป" ด้านบน',
            pwaStepChrome2: 'คลิกติดตั้ง',
            pwaStepEdge1: 'คลิกไอคอน "เพิ่มไปยังเดสก์ท็อป" ด้านบน',
            pwaStepEdge2: 'คลิกติดตั้ง',
            pwaStepSafari1: 'คลิกไอคอนเพิ่มเติม',
            pwaStepSafari2: 'คลิกแชร์',
            pwaStepSafari3: 'คลิกเพิ่มเติม',
            pwaStepSafari4: 'คลิกเพิ่มไปยังหน้าจอหลัก',
            pwaStepSafari5: 'คลิกเพิ่ม',
            pwaPromptTitle: 'เพิ่ม 微鲤AI ไปยังเดสก์ท็อป',
            pwaPromptDesc: 'เพิ่มไปยังหน้าจอหลักและรับ 15 คะแนน',
            pwaPromptBtn: 'เพิ่ม',
        },
    },
    da: {
        signIn: {
            inviteFriends: 'Inviter venner',
            todayLimit: 'Dagens grænse',
            copyLink: 'Kopier link',
            copySuccess: 'Kopieret',
            validInvites: 'Gyldige invitationer',
            people: 'personer',
            today: 'I dag',
            pending: 'Afventer',
            claimNow: 'Hent nu',
            claimSuccess: 'Hentet med succes',
            claimFailed: 'Hentning mislykkedes, prøv igen senere',
            noPendingRewards: 'Ingen belønninger at hente',
            forEachFriend: 'For hver inviteret ven',
            ruleText: 'Regel: Din ven skal registrere sig via dit link og',
            completeGeneration: 'gennemføre én AI-generering',
            afterReward: 'for at modtage belønning.',
            dailyLimitTip: '* Daglig invitationsbelønningsgrænse: 10 personer, opdateres næste dag.',
            promotionText:
                'Vil du bruge nanobanna, VEO, seedream gratis? Tilmeld dig 微鲤AI for at få gratis tokens og oplev glæden ved AI-skabelse!',
            taskCenter: 'Opgavecenter',
            addToDesktop: 'Tilføj 微鲤AI til skrivebordet og få adgang derfra',
            goComplete: 'Gå',
            completed: 'Fuldført',
            tokens: 'Credits',
            pwaGuideTitle: 'Sæt 微鲤AI på dit skrivebord',
            pwaGuideDesc: 'Åbner hurtigere, mere fordybende, uden at finde browseren hver gang',
            browserNotSupported: 'Din browser understøtter ikke denne funktion. Brug venligst Chrome, Edge eller Safari',
            pwaStepChrome1: 'Klik på "Tilføj til skrivebord"-ikonet øverst',
            pwaStepChrome2: 'Klik på Installer',
            pwaStepEdge1: 'Klik på "Tilføj til skrivebord"-ikonet øverst',
            pwaStepEdge2: 'Klik på Installer',
            pwaStepSafari1: 'Klik på Mere-ikonet',
            pwaStepSafari2: 'Klik på Del',
            pwaStepSafari3: 'Klik på Mere',
            pwaStepSafari4: 'Klik på Tilføj til startskærm',
            pwaStepSafari5: 'Klik på Tilføj',
            pwaPromptTitle: 'Tilføj 微鲤AI til skrivebordet',
            pwaPromptDesc: 'Tilføj til startskærm og få 15 point',
            pwaPromptBtn: 'Tilføj',
        },
    },
    no: {
        signIn: {
            inviteFriends: 'Inviter venner',
            todayLimit: 'Dagens grense',
            copyLink: 'Kopier lenke',
            copySuccess: 'Kopiert',
            validInvites: 'Gyldige invitasjoner',
            people: 'personer',
            today: 'I dag',
            pending: 'Venter',
            claimNow: 'Hent nå',
            claimSuccess: 'Hentet',
            claimFailed: 'Henting mislyktes, prøv igjen senere',
            noPendingRewards: 'Ingen belønninger å hente',
            forEachFriend: 'For hver invitert venn',
            ruleText: 'Regel: Vennen din må registrere seg via lenken din og',
            completeGeneration: 'fullføre én AI-generering',
            afterReward: 'for å motta belønning.',
            dailyLimitTip: '* Daglig invitasjonsbelønningsgrense: 10 personer, oppdateres neste dag.',
            promotionText:
                'Vil du bruke nanobanna, VEO, seedream gratis? Registrer deg på 微鲤AI for å få gratis tokens og opplev gleden ved AI-skaping!',
            taskCenter: 'Oppgavesenter',
            addToDesktop: 'Legg til 微鲤AI på skrivebordet og få tilgang derfra',
            goComplete: 'Gå',
            completed: 'Fullført',
            tokens: 'Credits',
            pwaGuideTitle: 'Sett 微鲤AI på skrivebordet',
            pwaGuideDesc: 'Åpner raskere, mer engasjerende, uten å finne nettleseren hver gang',
            browserNotSupported: 'Nettleseren din støtter ikke denne funksjonen. Vennligst bruk Chrome, Edge eller Safari',
            pwaStepChrome1: 'Klikk på "Legg til på skrivebordet"-ikonet øverst',
            pwaStepChrome2: 'Klikk på Installer',
            pwaStepEdge1: 'Klikk på "Legg til på skrivebordet"-ikonet øverst',
            pwaStepEdge2: 'Klikk på Installer',
            pwaStepSafari1: 'Klikk på Mer-ikonet',
            pwaStepSafari2: 'Klikk på Del',
            pwaStepSafari3: 'Klikk på Mer',
            pwaStepSafari4: 'Klikk på Legg til på startskjermen',
            pwaStepSafari5: 'Klikk på Legg til',
            pwaPromptTitle: 'Legg til 微鲤AI på skrivebordet',
            pwaPromptDesc: 'Legg til på startskjermen og få 15 poeng',
            pwaPromptBtn: 'Legg til',
        },
    },
    nl: {
        signIn: {
            inviteFriends: 'Vrienden uitnodigen',
            todayLimit: 'Limiet vandaag',
            copyLink: 'Link kopiëren',
            copySuccess: 'Gekopieerd',
            validInvites: 'Geldige uitnodigingen',
            people: 'mensen',
            today: 'Vandaag',
            pending: 'In behandeling',
            claimNow: 'Nu claimen',
            claimSuccess: 'Succesvol geclaimd',
            claimFailed: 'Claimen mislukt, probeer het later opnieuw',
            noPendingRewards: 'Geen beloningen om te claimen',
            forEachFriend: 'Voor elke uitgenodigde vriend',
            ruleText: 'Regel: Je vriend moet zich registreren via je link en',
            completeGeneration: 'één AI-generatie voltooien',
            afterReward: 'om de beloning te ontvangen.',
            dailyLimitTip: '* Dagelijkse uitnodigingsbeloning limiet: 10 personen, wordt de volgende dag vernieuwd.',
            promotionText:
                'Wil je nanobanna, VEO, seedream gratis gebruiken? Registreer je bij 微鲤AI om gratis tokens te krijgen en ervaar het plezier van AI-creatie!',
            taskCenter: 'Taakcentrum',
            addToDesktop: 'Voeg 微鲤AI toe aan bureaublad en open vanaf daar',
            goComplete: 'Ga',
            completed: 'Voltooid',
            tokens: 'Credits',
            pwaGuideTitle: 'Zet 微鲤AI op je bureaublad',
            pwaGuideDesc: 'Opent sneller, meer meeslepend, zonder elke keer de browser te zoeken',
            browserNotSupported: 'Je browser ondersteunt deze functie niet. Gebruik Chrome, Edge of Safari',
            pwaStepChrome1: 'Klik op het "Toevoegen aan bureaublad"-pictogram bovenaan',
            pwaStepChrome2: 'Klik op Installeren',
            pwaStepEdge1: 'Klik op het "Toevoegen aan bureaublad"-pictogram bovenaan',
            pwaStepEdge2: 'Klik op Installeren',
            pwaStepSafari1: 'Klik op het Meer-pictogram',
            pwaStepSafari2: 'Klik op Delen',
            pwaStepSafari3: 'Klik op Meer',
            pwaStepSafari4: 'Klik op Zet op beginscherm',
            pwaStepSafari5: 'Klik op Voeg toe',
            pwaPromptTitle: 'Voeg 微鲤AI toe aan bureaublad',
            pwaPromptDesc: 'Voeg toe aan beginscherm en krijg 15 punten',
            pwaPromptBtn: 'Toevoegen',
        },
    },
    id: {
        signIn: {
            inviteFriends: 'Undang Teman',
            todayLimit: 'Batas Hari Ini',
            copyLink: 'Salin Tautan',
            copySuccess: 'Disalin',
            validInvites: 'Undangan Valid',
            people: 'orang',
            today: 'Hari ini',
            pending: 'Tertunda',
            claimNow: 'Klaim Sekarang',
            claimSuccess: 'Berhasil diklaim',
            claimFailed: 'Gagal klaim, coba lagi nanti',
            noPendingRewards: 'Tidak ada hadiah untuk diklaim',
            forEachFriend: 'Untuk setiap teman yang diundang',
            ruleText: 'Aturan: Teman harus mendaftar melalui tautan Anda dan',
            completeGeneration: 'menyelesaikan satu generasi AI',
            afterReward: 'untuk menerima hadiah.',
            dailyLimitTip: '* Batas hadiah undangan harian: 10 orang, diperbarui keesokan harinya.',
            promotionText:
                'Ingin menggunakan nanobanna, VEO, seedream gratis? Daftar di 微鲤AI untuk mendapatkan token gratis dan rasakan kegembiraan kreasi AI!',
            taskCenter: 'Pusat Tugas',
            addToDesktop: 'Tambahkan 微鲤AI ke desktop dan akses dari sana',
            goComplete: 'Pergi',
            completed: 'Selesai',
            tokens: 'Kredit',
            pwaGuideTitle: 'Letakkan 微鲤AI di Desktop',
            pwaGuideDesc: 'Buka lebih cepat, lebih imersif, tanpa perlu mencari browser setiap saat',
            browserNotSupported: 'Browser Anda tidak mendukung fitur ini. Silakan gunakan Chrome, Edge, atau Safari',
            pwaStepChrome1: 'Klik ikon "Tambahkan ke Desktop" di bagian atas',
            pwaStepChrome2: 'Klik Instal',
            pwaStepEdge1: 'Klik ikon "Tambahkan ke Desktop" di bagian atas',
            pwaStepEdge2: 'Klik Instal',
            pwaStepSafari1: 'Klik ikon Lainnya',
            pwaStepSafari2: 'Klik Bagikan',
            pwaStepSafari3: 'Klik Lainnya',
            pwaStepSafari4: 'Klik Tambahkan ke Layar Utama',
            pwaStepSafari5: 'Klik Tambahkan',
            pwaPromptTitle: 'Tambahkan 微鲤AI ke Desktop',
            pwaPromptDesc: 'Tambahkan ke layar utama dan dapatkan 15 poin',
            pwaPromptBtn: 'Tambahkan',
        },
    },
    tr: {
        signIn: {
            inviteFriends: 'Arkadaş Davet Et',
            todayLimit: 'Bugünkü Limit',
            copyLink: 'Bağlantıyı Kopyala',
            copySuccess: 'Kopyalandı',
            validInvites: 'Geçerli Davetler',
            people: 'kişi',
            today: 'Bugün',
            pending: 'Bekliyor',
            claimNow: 'Şimdi Al',
            claimSuccess: 'Başarıyla alındı',
            claimFailed: 'Alma başarısız, daha sonra tekrar deneyin',
            noPendingRewards: 'Alınacak ödül yok',
            forEachFriend: 'Davet edilen her arkadaş için',
            ruleText: 'Kural: Arkadaşınız bağlantınız üzerinden kaydolmalı ve',
            completeGeneration: 'bir AI üretimi tamamlamalı',
            afterReward: 'ödülü almak için.',
            dailyLimitTip: '* Günlük davet ödül limiti: 10 kişi, ertesi gün yenilenir.',
            promotionText:
                'nanobanna, VEO, seedream\'i ücretsiz kullanmak ister misiniz? 微鲤AI\'ye kaydolun, ücretsiz token kazanın ve AI yaratıcılığının keyfini çıkarın!',
            taskCenter: 'Görev Merkezi',
            addToDesktop: '微鲤AI\'yi masaüstüne ekle ve oradan eriş',
            goComplete: 'Git',
            completed: 'Tamamlandı',
            tokens: 'Kredi',
            pwaGuideTitle: '微鲤AI\'yi Masaüstüne Koy',
            pwaGuideDesc: 'Daha hızlı açılır, daha sürükleyici, her seferinde tarayıcı aramaya gerek yok',
            browserNotSupported: 'Tarayıcınız bu özelliği desteklemiyor. Lütfen Chrome, Edge veya Safari kullanın',
            pwaStepChrome1: 'Üstteki "Masaüstüne Ekle" simgesine tıklayın',
            pwaStepChrome2: 'Yükle\'ye tıklayın',
            pwaStepEdge1: 'Üstteki "Masaüstüne Ekle" simgesine tıklayın',
            pwaStepEdge2: 'Yükle\'ye tıklayın',
            pwaStepSafari1: 'Daha Fazla simgesine tıklayın',
            pwaStepSafari2: 'Paylaş\'a tıklayın',
            pwaStepSafari3: 'Daha Fazla\'ya tıklayın',
            pwaStepSafari4: 'Ana Ekrana Ekle\'ye tıklayın',
            pwaStepSafari5: 'Ekle\'ye tıklayın',
            pwaPromptTitle: '微鲤AI\'yi Masaüstüne Ekle',
            pwaPromptDesc: 'Ana ekrana ekle ve 15 puan kazan',
            pwaPromptBtn: 'Ekle',
        },
    },
    pl: {
        signIn: {
            inviteFriends: 'Zaproś znajomych',
            todayLimit: 'Dzisiejszy limit',
            copyLink: 'Kopiuj link',
            copySuccess: 'Skopiowano',
            validInvites: 'Ważne zaproszenia',
            people: 'osób',
            today: 'Dzisiaj',
            pending: 'Oczekuje',
            claimNow: 'Odbierz teraz',
            claimSuccess: 'Odebrano pomyślnie',
            claimFailed: 'Odbiór nie powiódł się, spróbuj ponownie później',
            noPendingRewards: 'Brak nagród do odebrania',
            forEachFriend: 'Za każdego zaproszonego znajomego',
            ruleText: 'Zasada: Znajomy musi zarejestrować się przez Twój link i',
            completeGeneration: 'ukończyć jedną generację AI',
            afterReward: 'aby otrzymać nagrodę.',
            dailyLimitTip: '* Dzienny limit nagród za zaproszenia: 10 osób, odświeża się następnego dnia.',
            promotionText:
                'Chcesz używać nanobanna, VEO, seedream za darmo? Zarejestruj się w 微鲤AI, aby otrzymać darmowe tokeny i doświadczyć radości tworzenia z AI!',
            taskCenter: 'Centrum zadań',
            addToDesktop: 'Dodaj 微鲤AI do pulpitu i uzyskaj dostęp stamtąd',
            goComplete: 'Idź',
            completed: 'Ukończone',
            tokens: 'Kredyty',
            pwaGuideTitle: 'Umieść 微鲤AI na pulpicie',
            pwaGuideDesc: 'Otwiera się szybciej, bardziej wciągające, bez szukania przeglądarki za każdym razem',
            browserNotSupported: 'Twoja przeglądarka nie obsługuje tej funkcji. Użyj Chrome, Edge lub Safari',
            pwaStepChrome1: 'Kliknij ikonę "Dodaj do pulpitu" na górze',
            pwaStepChrome2: 'Kliknij Zainstaluj',
            pwaStepEdge1: 'Kliknij ikonę "Dodaj do pulpitu" na górze',
            pwaStepEdge2: 'Kliknij Zainstaluj',
            pwaStepSafari1: 'Kliknij ikonę Więcej',
            pwaStepSafari2: 'Kliknij Udostępnij',
            pwaStepSafari3: 'Kliknij Więcej',
            pwaStepSafari4: 'Kliknij Dodaj do ekranu głównego',
            pwaStepSafari5: 'Kliknij Dodaj',
            pwaPromptTitle: 'Dodaj 微鲤AI do pulpitu',
            pwaPromptDesc: 'Dodaj do ekranu głównego i zdobądź 15 punktów',
            pwaPromptBtn: 'Dodaj',
        },
    },
}
